import React from 'react';

function ManagementActionBlock({ id, label, children }) {
  return (
    <div id={id ? id : null} className="management-action-block">
      {children}
      <p className="management-action-block__label">
        {label}
      </p>
    </div>
  )
}

export default ManagementActionBlock;
